import React, { Component } from 'react'
import '../styles/OrganizationAECommittee.css'
import APIGenericRequest from '../api/APIGenericRequest'
import OrgFooter from '../widgets/OrgFooter'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import DropdownWidget from '../widgets/DropdownWidget'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'

class OrganizationAECommittee extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			dateToday: sessionStorage.getItem("date-today"),
			arboId: sessionStorage.getItem("arbo-id"),
			scrollable: false,
			aeItemObj: {},
			aeKeyTracer: 0,
			aeListItems: [],
			members: {},
			deleteMembers: {},
			shouldDisplayValues: props.displayValues,
			isViewDetails: props.isViewDetails
		}
		this.setScrollable = this.setScrollable.bind(this)
		this.aeEventHandler = this.aeEventHandler.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.setAECMember = this.setAECMember.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const members = []
		const addMembers = []
		Object.values(this.state.members).forEach((v) => {
			if(v.arbo_aec_member_id != null) {
				members.push(v)
			}
			else {
				addMembers.push(v)
			}
		})
		const deleteMembers = []
		Object.values(this.state.deleteMembers).forEach((v) => {
			deleteMembers.push({arbo_aec_member_id: v.arbo_aec_member_id})
		})
		if(members.length > 0 || deleteMembers.length > 0) {
			var data = {
				AECMember: members,
				add: {AECMember: addMembers},
				delete: {AECMember: deleteMembers}
			}
		}
		else {
			data = {AECMember: addMembers}
		}
		if(data.add == null && data.delete == null && members.length < 1) {
			const apiReq = APIOrganizationRequest.addAECommitteeByArboId(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false,
					members: {},
					addMembers: {}
				})
			})
		}
		else {
			const apiReq = APIOrganizationRequest.editAECommitteeByArboId(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false,
					members: {},
					addMembers: {}
				})
			})
		}
	}

	componentDidMount() {
		console.log('componentDidMount', this.state.arboId)
		this.setState({showActivityIndicator: true})
		const obi = APIOrganizationRequest.getFarmerOrgById(this.state.accessToken, this.state.arboId)
		obi.then((response) => {
			console.log('getFarmerOrgById', response)
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				orgName: response.results.name,
				partnershipType: response.results.category,
				province: response.results.province,
				city: response.results.city,
				arcName: response.results.arc_name,
				partnershipDate: response.results.partnership_date,
			})
			const aec = APIOrganizationRequest.getAECommitteeByArboId(this.state.accessToken, this.state.arboId)
			aec.then((response) => {
				console.log('getAECommitteeByArboId', response)
				// if(response.status !== "SUCCESS") {
				// 	this.setState({
				// 		showWarningMessage: true,
				// 		aMessage: response.status + "! " + response.description + ": " + response.results,
				// 		showActivityIndicator: false
				// 	})
				// 	return
				// }
				this.setAECMember(response.results?.AECMember)
				this.setScrollable()
			})
		})
		window.addEventListener('resize', this.onResize.bind(this))
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
	}

	setAECMember(aecMembers) {
		const members = []
		if(aecMembers != null) {
			for(const v of aecMembers) {
				const aeKey = "ae-" + this.state.aeKeyTracer
				this.state.aeItemObj[aeKey] = <AECMember data={v} handler={this.aeEventHandler}
					disabled={this.state.isViewDetails}  key={aeKey} id={aeKey} />
				this.state.aeKeyTracer++
			}
			const aeKey = "ae-" + this.state.aeKeyTracer
			this.state.aeItemObj[aeKey] = <AECMember handler={this.aeEventHandler}
				disabled={this.state.isViewDetails} key={aeKey} id={aeKey} />
			this.state.aeKeyTracer++
			Object.keys(this.state.aeItemObj).forEach((k => {
				members.push(this.state.aeItemObj[k])
			}))
		}
		else {
			const aeKey = "ae-" + this.state.aeKeyTracer
			this.state.aeItemObj[aeKey] = <AECMember handler={this.aeEventHandler} key={aeKey} id={aeKey} />
			this.state.aeKeyTracer++
			members.push(this.state.aeItemObj[aeKey])
		}
		this.setState({aeListItems: members, showActivityIndicator: false})
	}

	aeEventHandler(e, compId, key, value) {
		switch(e) {
			case "member":
				this.state.members[compId] = value
				break
			case "add":
				this.state.members[compId] = value
				const added = []
				const aeKey = "ae-" + this.state.aeKeyTracer
				this.state.aeItemObj[aeKey] = <AECMember handler={this.aeEventHandler} key={aeKey} id={aeKey} />
				this.state.aeKeyTracer++
				this.state.aeListItems.push(this.state.aeItemObj[aeKey])
				Object.keys(this.state.aeItemObj).forEach((k => {
					added.push(this.state.aeItemObj[k])
				}))
				this.setState({aeListItems: added})
				break
			case "delete":
				this.state.deleteMembers[compId] = value
				delete this.state.aeItemObj[compId]
				const deleted = []
				Object.keys(this.state.aeItemObj).forEach((k => {
					deleted.push(this.state.aeItemObj[k])
				}))
				this.setState({aeListItems: deleted})
		}
		this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('oae-scroll-area')
		const ca = document.getElementById('oae-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+60) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="org-committee">
			<div id="oae-scroll-area"><div id="oae-client-area">
				<div id="oae-cell1">
					<div id="oae-cell1-r1">
						<div id="oae-cell1-r1-i1">
							<div>Organization Name</div>
							<input type="text" value={this.state.orgName} disabled="true" />
						</div>
						<div id="oae-cell1-r1-i2">
							<div>Type</div>
							<input type="text" value={this.state.partnershipType} disabled="true" />
						</div>
					</div>
					<div id="oae-cell1-r2">
						<div id="oae-cell1-r2-i1">
							<div>Province</div>
							<input type="text" value={this.state.province} disabled="true" />
						</div>
						<div id="oae-cell1-r2-i2">
							<div>Municipality</div>
							<input type="text" value={this.state.city} disabled="true" />
						</div>
						<div id="oae-cell1-r2-i3">
							<div>Name of Agrarian Reform Community</div>
							<input type="text" value={this.state.arcName} disabled="true" />
						</div>
					</div>
				</div>
				<div className="title-bar">AEC MEMBERSHIP</div>
				<div id="oae-cell2">
					<table className="ae-table-header">
						<col style={{width: '55%'}} />
						<col style={{width: '45%'}} />
						<tr>
							<th>Name of Member</th>
							<th>Position</th>
						</tr>
					</table>
					{this.state.aeListItems}
				</div>
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.isViewDetails} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} disabled={this.state.isViewDetails} showSubmit={true} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class AECMember extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			ext: "EXT",
			member: {},
			disabled: props.disabled
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			this.setState({extName: c})
		})
	}

	componentDidMount() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			this.setState({extName: c})
		})
		if(this.props.data != null) {
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.state.member["arbo_aec_member_id"] = this.props.data.arbo_aec_member_id
			this.setState({
				ext: (this.props.data.extension_name == null)? "N/A": this.props.data.extension_name,
				firstName: this.props.data.first_name,
				middleName: this.props.data.middle_name,
				lastName: this.props.data.last_name,
				position: this.props.data.aec_position,
				member: {
					extension_name: this.props.data.extension_name,
					first_name: this.props.data.first_name,
					middle_name: this.props.data.middle_name,
					last_name: this.props.data.last_name,
					aec_position: this.props.data.aec_position,
					arbo_aec_member_id: this.props.data.arbo_aec_member_id
				},
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.member)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		// this.props.handler("delete", this.state.itemId, null, this.state.member)
		const fn = this.state.member.first_name? this.state.member.first_name: ''
		const ln = this.state.member.last_name? this.state.member.last_name: ''
		const name = `${fn} ${ln}`
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove member ${name.toUpperCase()}?`
		})
	}

	render() {
		const view = <div className="aec-member">
			<div>{this.state.addDeleteButton}</div>
			<table className="ae-table-data">
					<col style={{width: '55%'}} />
					<col style={{width: '45%'}} />
				<tr>
					<td><div>
						<input className="aec-firstname" type="text" value={this.state.firstName} placeholder="FIRST NAME" onChange={(e) =>{
							this.state.member["first_name"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({firstName: e.target.value})
						}} disabled={this.state.disabled} />
						<input className="aec-middlename" type="text" value={this.state.middleName} placeholder="MIDDLE NAME" onChange={(e) =>{
							this.state.member["middle_name"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({middleName: e.target.value})
						}} disabled={this.state.disabled} />
						<input className="aec-lastname" type="text" value={this.state.lastName} placeholder="LAST NAME" onChange={(e) =>{
							this.state.member["last_name"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({lastName: e.target.value})
						}} disabled={this.state.disabled} />
						<DropdownWidget list={this.state.extName} placeholder={this.state.ext} cStyle={{"width": "60px"}}
							onItemSelected={(id, val) => {
								this.state.member["extension_name"] = val
								this.props.handler("member", this.state.itemId, null, this.state.member)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
					</div></td>
					<td><input className="aec-position" type="text" value={this.state.position} onChange={(e) =>{
							this.state.member["aec_position"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({position: e.target.value})
						}} disabled={this.state.disabled} /></td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					this.setState({showConfirmMessage: false})
					if(e.target.innerHTML === "NO") {
					}
					else {
						this.props.handler("delete", this.state.itemId, null, this.state.member)
					}
			}} />}
		</div>
		return(view)
	}
}

export default OrganizationAECommittee
